// eslint-disable-next-line import/no-unresolved

export const MODAL_STYLES = {
  dialog: {
    header: {
      className:
        "tw-cursor-move tw-text-xl tw-font-medium tw-text-primary tw-mb-4",
    },
    mask: {
      className: "tw-bg-black tw-bg-opacity-50 !tw-z-20",
    },
  },
  dropdown: {
    root: {
      className:
        "tw-cursor-pointer tw-w-full tw-border tw-rounded tw-border-neutral-25 tw-flex tw-flex-row hover:tw-border-black",
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    input: ({ props }: any) => {
      return {
        className: `tw-w-full tw-p-2 ${
          props.value ? "tw-text-text-50" : "tw-text-neutral-50"
        } tw-truncate`,
      }
    },
    trigger: {
      className: "tw-py-2 tw-px-3 tw-text-gray-500 tw-flex tw-items-center",
    },
    panel: {
      className: "tw-bg-white tw-py-1 tw-rounded tw-shadow",
    },
    hiddenfirstfocusableel: {
      className: "focus:tw-border focus:tw-border-black",
    },
    filtercontainer: {
      className:
        "tw-w-full tw-bg-[#F8F9FA] tw-px-4 tw-py-2 tw-flex tw-items-center tw-relative",
    },
    filterinput: {
      className:
        "tw-w-full tw-border tw-border-neutral-25 tw-py-2 tw-pl-2 tw-pr-6 tw-rounded",
    },
    filtericon: {
      className: "tw-right-6 tw-absolute",
    },
    wrapper: {
      className: "tw-overflow-auto",
    },
    itemgroup: {
      className: "tw-font-semibold tw-px-4 tw-py-3",
    },
    item: {
      className:
        "tw-cursor-pointer tw-text-text-50 tw-py-2 tw-px-4 tw-overflow-hidden hover:tw-bg-gray-200 hover:tw-text-gray-700 aria-[selected=true]:tw-bg-[#E3F2FD] tw-truncate",
    },
  },
  calendar: {
    root: {
      className: "tw-box-border tw-flex tw-flex-row tw-rounded-md",
    },
    input: {
      root: {
        className:
          "tw-w-full tw-p-2 tw-rounded-l-md tw-border tw-border-[#E5E7EB]",
      },
    },
    dropdownbutton: {
      root: {
        className:
          "!tw-bg-primary tw-w-10 tw-border tw-border-primary tw-py-2 tw-pl-3 tw-pr-2 tw-rounded-r-md tw-items-center tw-text-white tw-flex tw-items-center tw-text-base",
      },
    },
    inputtext: {
      className: "!tw-p-2",
    },
    panel: {
      className: "tw-p-2 tw-bg-white tw-rounded-sm tw-shadow-md",
    },
    header: {
      className:
        "tw-p-2 tw-flex tw-justify-between tw-border-b tw-border-[#DEE2E6]",
    },
    title: {
      className: "tw-text-text-50 tw-font-medium",
    },
    monthtitle: {
      className: "tw-mr-2",
    },
    previousbutton: {
      className: "tw-text-[#6c757d]",
    },
    nextbutton: {
      className: "tw-text-[#6c757d]",
    },
    container: {
      className: "tw-box-border",
    },
    table: {
      className:
        "tw-my-2 tw-text-center tw-text-base tw-text-text-50 tw-w-full",
    },
    tableheadercell: {
      className: "tw-p-2",
    },
    day: {
      className: "tw-p-2 tw-text-center tw-text-text-50 tw-text-base",
    },
    daylabel: {
      className:
        "tw-w-9 tw-h-9 tw-cursor-pointer tw-flex tw-items-center tw-justify-center tw-rounded-full data-[p-highlight=true]:tw-bg-[#E3F2FD] hover:data-[p-highlight=false]:tw-bg-[#E9ECEF] hover:data-[p-disabled=true]:tw-bg-white data-[p-disabled=true]:tw-pointer-events-none data-[p-disabled=true]:tw-opacity-60",
    },
    monthpicker: {
      className: "tw-my-2 tw-grid tw-grid-cols-3",
    },
    month: {
      className:
        "tw-p-2 tw-text-center tw-text-text-50 tw-text-base tw-cursor-pointer data-[p-highlight=true]:tw-bg-[#E3F2FD] hover:data-[p-highlight=false]:tw-bg-[#E9ECEF]",
    },
    yearpicker: {
      className: "tw-my-2 tw-grid tw-grid-cols-2",
    },
    year: {
      className:
        "tw-p-2 tw-text-center tw-text-text-50 tw-text-base tw-cursor-pointer data-[p-highlight=true]:tw-bg-[#E3F2FD] hover:data-[p-highlight=false]:tw-bg-[#E9ECEF] data-[p-disabled=true]:tw-opacity-60 data-[p-disabled=true]:tw-pointer-events-none",
    },
  },
}

export const PAGINATION_STYLES =
  "!tw-bg-white tw-sticky tw-bottom-0 tw-right-0 !tw-mb-0 !tw-h-15 tw-justify-end"
